if (!customElements.get('cart-recommendations')) {
  customElements.define(
    'cart-recommendations',
    class CartRecommendations extends HTMLElement {
      constructor() {
        super();
      }

      get url() {
        return this.dataset.url;
      }

      connectedCallback() {
        this.initRecommendations();
        this.initReturnsPopup();
      }

      initSlider(container) {
        if (!container) return;
        const options = {
          observer: true,
          observeParents: true,
          slidesPerMove: 1,
          grabCursor: true,
          slidesPerView: 2.2,
          spaceBetween: 4,
          slidesOffsetAfter: 10,
          noSwiping: true,
          noSwipingClass: 'swiper-no-swiping',
          watchOverflow: true,
          allowTouchMove: true,
          mousewheel: {
            forceToAxis: true,
          },
          breakpoints: {
            560: {
              slidesPerView: 2.8,
            },
          },
        };
        new Swiper(container, options);
      }

      initRecommendations() {
        const firstProductIdElement = document.querySelector('[data-first-product-id]');
        const recommendations = document.querySelector('.recommendation-slider-cart-drawer');
        if (!firstProductIdElement && !recommendations) return;

        const productId = firstProductIdElement.dataset.firstProductId;
        if (firstProductIdElement.hasAttribute('data-empty') || !this.url) {
          sessionStorage.setItem('recommendation_id', '');
          sessionStorage.setItem('recommendation_html', '');
        }

        if (sessionStorage.getItem('recommendation_id') && sessionStorage.getItem('recommendation_id') === productId) {
          recommendations.innerHTML = sessionStorage.getItem('recommendation_html');
          this.initSlider(recommendations);
        } else {
          this.url ? this.getRecommendations(recommendations, productId) : this.initSlider(recommendations);
        }
      }

      async getRecommendations(container, id) {
        const preloader = document.querySelector('.loading-cart');
        if(preloader) {
          preloader.classList.remove('hidden');
          container.classList.add('hidden');
        }
        const response = await fetch(this.url);
        const result = await response.text();
        const parser = new DOMParser().parseFromString(result, 'text/html');
        const newRecommendations = parser.querySelector('.recommendation-slider-cart-drawer');
        if (!newRecommendations || !container) return;

        container.innerHTML = newRecommendations.innerHTML;
        if(preloader) {
          preloader.classList.add('hidden');
          container.classList.remove('hidden');
        }
        this.initSlider(container);
        sessionStorage.setItem('recommendation_id', id);
        sessionStorage.setItem('recommendation_html', container.innerHTML);
      }

      initReturnsPopup() {
        const returnsElement = document.querySelector('.easy_returns_new');
        const returnsPopup = document.querySelector('[data-returns-popup]');
        const closeReturnsPopupButtons = document.querySelectorAll('[data-close-return-popup]');
        const openReturnsPopupButton = document.querySelector('[data-open-returns-popup]');
        if (!returnsElement || !returnsPopup || !openReturnsPopupButton) return;
        openReturnsPopupButton.addEventListener('click', () => {
          returnsElement.classList.add('active');
        });
        closeReturnsPopupButtons.forEach((button) => {
          button.addEventListener('click', () => {
            returnsElement.classList.remove('active');
          });
        });
      }
    },
  );
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth >= 1024) {
    const cardWrappers = document.querySelectorAll('.card-wrapper');

    cardWrappers.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        const quickAdd = card.querySelector('.quick-add');
        if (quickAdd) quickAdd.style.display = 'block';
      });

      card.addEventListener('mouseleave', function () {
        const quickAdd = card.querySelector('.quick-add');
        if (quickAdd) quickAdd.style.display = 'none';
      });
    });
  }
});